import { useState } from "react";

export const useHandleTableColWidths = ({
  tableConfig
}) => {
  const { colWidths, defaultColWidth, minColWidth = 200 } = tableConfig;

  const setInitConf = (tableConfig) => {
    let initConf = {};

    tableConfig.cellData.forEach(
      (d, i) =>
        (initConf[d.colId] = colWidths && colWidths[d.colId]
            ? colWidths[d.colId] + 'px'
            : defaultColWidth ? defaultColWidth+'px' : `${minColWidth}px`
        )
    );

    return initConf;
  };

  const [colWidthConfig, setColWidthConfig] = useState(
    setInitConf(tableConfig)
  );

  // The state map is seeded ONCE on mount — a colId that appears mid-session
  // (e.g. a field-type change re-keys its column) has no entry and the column
  // would collapse to zero width. Derive the missing entries per render
  // (user resizes live in state and still win); no setState, so no loops.
  const resolvedColWidthConfig = { ...setInitConf(tableConfig), ...colWidthConfig };

  return { colWidthConfig: resolvedColWidthConfig, setColWidthConfig, minColWidth };
};
